import { useState } from 'react';

import { Box, Text, Grid, Button } from '@simplywallst/ui-core';

import { pluralise } from '@/utilities/pluralise';

import type { Datum } from '../../types';
import { getSubTitle } from './utils';

import { OthersModal } from '../OthersModal';

export const OthersBreakdown = ({ data }: { data: Datum[] }) => {
  const [showModal, setShowModal] = useState(false);

  const title = `${data.length} ${pluralise(data.length, 'Other', 'Others')}`;

  return (
    <Box
      position="absolute"
      width={100}
      top="50%"
      left="50%"
      transform="translateX(-50%) translateY(-54%)"
    >
      <Grid minHeight={86} alignContent="space-between">
        <Box>
          <Text typography="smallStrong" color="whiteRGBA" opacity={0.3}>
            {title}
          </Text>
          <Text typography="tiny" color="white">
            {getSubTitle(data)}
          </Text>
        </Box>
        <Button styleType="louder" onClick={() => setShowModal(true)}>
          View all
        </Button>
      </Grid>
      {showModal && (
        <OthersModal data={data} onClose={() => setShowModal(false)} />
      )}
    </Box>
  );
};
